import type { FC } from "react";

import { Button } from "@recobra/ui/button";

import { useFormContext } from "./context";

export const SubmitButton: FC<{
  label: string;
  pendingLabel: string;
  disabled?: boolean;
}> = ({ label, pendingLabel, disabled = false }) => {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button type="submit" disabled={isSubmitting || disabled}>
          {isSubmitting ? pendingLabel : label}
        </Button>
      )}
    </form.Subscribe>
  );
};
